import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
var styles = {
  "root": "DropDown-root_slWR5"
};
function DropDown(_ref) {
  var className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      role: "menu",
      paddingY: "xsmall",
      borderRadius: "1x",
      backgroundColor: "white",
      className: clsx(styles.root, className)
    }, extraProps))
  );
}
export default DropDown;